<template>
  <div class="life-recad--documents">
    <div class="text-group">
      <h3 class="text-accent">LIFE RECAD</h3>
      <h1>{{ $t("life-recad-documents-1") }}</h1>
      <p>{{ $t("life-recad-documents-2") }}</p>
    </div>
    <div class="content-row">
      <Files color="#0054A4" :files="files" :liferecad="true" />
    </div>
  </div>
</template>

<script>
import Files from "../products/individuals/shared/Files.vue";
export default {
  components: {
    Files,
  },
  data() {
    return {
      files: {
        bg: [
          [
            ["kcm-liferecad-1.pdf"],
            "✅ Разработване на идеен проект",
            "Разработване на технологични схеми, апаратурно-технологични схеми и предварителни количествени сметки по отделните проектни части. Предаване на документация за съгласуване със строителен надзор. Подаване на документи за разрешение за строеж.",
          ],
          [
            ["kcm-liferecad-2.pdf"],
            "✅ Пакет за разпространение и комуникация",
            "Този пакет ще включва най-различни рекламни материали, като брошури, листовки, информационни табели и други. В допълнение ще бъдат извършвани дейности за популяризиране проекта и резултатите от реализирането му, като например публикации в медиите, социалните мрежи и други средства за масова комуникация.",
          ],
          [
            null,
            "🔴Пазарен анализ",
            "Разработване на доклад за мерките, инструментите и рамката за сътрудничество засягаща възможностите за разпространение и пренос на информацията генерирана от проектното решение. Докладът ще бъде разработен на български и английски език.",
          ],
          [
            null,
            "🔴Разработване на работен проект",
            "Продължение на разработките от Технически проект, включвайки детайли, като чертежи за технологични комуникации, оборудване. Разработване на концепция за управление на процесите.",
          ],
          [
            null,
            "🔴Експлоатационен план и бизнес стратегия",
            "Разработване на план от минимум 30 страници на български и английски, очертаващ кратко- и дългосрочни цели, таргет групи, мерки, индикатори, размер на пазара, клиенти, конкуренти, финансов план и др.",
          ],
          [
            null,
            "🔴Програма за контрол измерване и автоматизация,",
            "Внимателно разработена програма за контрол, измерване и автоматизация на процесите протичащи в инсталацията за очистване на отпадни води, от която ще се събират данни за ефективността, на база на които ще бъде разработен подробен доклад",
          ],
          [
            null,
            "🔴Експлоатация и надграждането на резултатите от проекта",
            "Докладът ще бъде основата за продължаващи подобрения и мащабируемост на проекта",
          ],
          [
            null,
            "🔴Оценка състоянието на р. Чая и разработване на интегрирани мерки за облекчаване на оказаният натиск",
            "Ще се осъществят замервания за съдържанието на Кадмий във водите в реката, както и на биотичните и трофичните индекси. Замерванията ще се направят 2 пъти годишно в продължение на изпълнение на проекта и след внедряване на технологичното отделение. На база тези замервания, ще бъде направена оценка и посочени мерки за намаляване въздействието на производството върху реката.",
          ],
          [
            null,
            "🔴Оперативен мониторинг на локално стъпало",
            "Писмен резултат, синтезиращ основните данни и заключения относно функционалността на очистващата инсталация и нейната ефективност",
          ],
          [
            null,
            "🔴Резултат от оценка на жизненият цикъл",
            "Резултатите от оценката на жизненият цикъл ще бъдат включени в специален доклад, който ще бъде публикуван в секцията отредена за проекта на сайта на компанията и разпространена сред заинтересованите страни. Докладът ще бъде разработен на български и английски език. В него ще бъдат включени екологичните разходи по изграждане и експлоатация на технологията и сравнение между използваната и алтернативни на нея методи",
          ],
          [
            null,
            "🔴Стратегия за намалявана на кадмия в храните",
            "Разработване на стратегия, базирана на комуникация със засегнати страни, включваща конкретни одобрени мерки",
          ],
          [
            null,
            "🔴Начало планиране разпространението и дейности по комуникация",
            "Разпространението на информацията за проекта стартира още с въвеждането на отделната секция на сайта на компанията и продължава по време на и след изпълнението на проекта. Целта е проследимост на процеса на изпълнение, както и достъпността на резултатите от широката аудитория. Надграждането на резултатите от проекта е също важен етап от неговият живот и информация за това ще бъде налична и след приключването на проекта.",
          ],
          [
            null,
            "🔴План After-LIFE",
            "Очертаване насока за продължаване въздействието на резултатите от въвеждане в експлоатация на пречистваща инсталация",
          ],
        ],
        en: [
          [
            ["kcm-liferecad-1.pdf"],
            "✅Development of a conceptual design",
            "Development of technological schemes, apparatus-technological schemes and preliminary quantitative accounts of the individual project parts. Submission of documentation for coordination with construction supervision. Submission of construction permit documents.",
          ],
          [
            ["kcm-liferecad-2.pdf"],
            "✅ Dissemination and communication package",
            "This package will include a variety of promotional material such as brochures, leaflets, information boards, etc. In addition, activities will be carried out to promote the project and its results, such as publications in the media, social networks and other means of mass communication.",
          ],
          [
            null,
            "🔴Market analysis",
            "Development of a report on the measures, tools and cooperation framework concerning the possibilities for dissemination and transfer of the information generated by the project solution. The report will be developed in Bulgarian and English.",
          ],
          [
            null,
            "🔴Development of a detailed design",
            "Continuation of the developments from the Technical Project, including details such as drawings for technological communications, equipment. Development of a process control concept.",
          ],
          [
            null,
            "🔴Operation plan and business strategy",
            "Development of a plan of at least 30 pages in Bulgarian and English, outlining short- and long-term objectives, target groups, measures, indicators, market size, customers, competitors, financial plan, etc.",
          ],
          [
            null,
            "🔴Control measurement and automation program",
            "A carefully designed programme for the control, measurement and automation of the processes taking place in the wastewater treatment plant, from which performance data will be collected, on the basis of which a detailed report will be developed",
          ],
          [
            null,
            "🔴Operation and upgrade of project results",
            "The report will form the basis for ongoing improvements and scalability of the project",
          ],
          [
            null,
            "🔴Assessment of the status of the river. Chaya and development of integrated measures to alleviate the pressure",
            "Measurements of the Cadmium content of the river water, as well as biotic and trophic indices will be carried out. Measurements will be made 2 times per year during project implementation and after implementation of the process compartment. Based on these measurements, an assessment will be made and measures to reduce the impact of production on the river will be indicated.",
          ],
          [
            null,
            "🔴Operational monitoring of local stage",
            "A written deliverable synthesising the main data and conclusions on the functionality of the treatment plant and its efficiency",
          ],
          [
            null,
            "🔴Result of life cycle assessment",
            "The results of the life cycle assessment will be included in a special report to be published in the section dedicated to the project on the company's website and distributed to stakeholders. The report will be developed in Bulgarian and English. It will include the environmental costs of the construction and operation of the technology and a comparison between the technology used and alternative methods",
          ],
          [
            null,
            "🔴Strategy for cadmium reduction in foods",
            "Development of a strategy, based on communication with affected parties, including specific approved measures",
          ],
          [
            null,
            "🔴Initiation of dissemination planning and communication activities",
            "Dissemination of information about the project started with the introduction of the separate section on the company's website and continued during and after the project. The aim is traceability of the implementation process as well as the accessibility of the results by a wide audience. Building on the results of the project is also an important stage in its life and information on this will be available after the project has ended.",
          ],
          [
            null,
            "🔴After-LIFE Plan",
            "Outlining a direction for the continued impact of the results of the commissioning of the treatment plant",
          ],
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.life-recad--documents {
  .text-group {
    padding: 2rem $sidesPadding;
  }
  .content-row {
    padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
    padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  }
}

@media screen and (max-width: 1600px) {
  .life-recad--documents {
    .text-group {
      padding-right: $sidesPadding1600;
      padding-left: $sidesPadding1600;
    }
    .content-row {
      padding-right: $sidesPadding1600 + $chemicalLarge +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1440px) {
  .life-recad--documents {
    .content-row {
      padding-right: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1280px) {
  .life-recad--documents {
    .text-group {
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
    }
    .content-row {
      padding-right: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
      padding-left: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
    }
  }
}
@media screen and (max-width: 1000px) {
  .life-recad--documents {
    .content-row {
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
    }
  }
}
@media screen and (max-width: 600px) {
  .life-recad--documents {
    .text-group {
      padding-right: $sidesPadding600;
      padding-left: $sidesPadding600;
    }
    .content-row {
      padding-right: $sidesPadding600;
      padding-left: $sidesPadding600;
    }
  }
}
</style>
